var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBannerGrid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1380,
    height: 986,
    viewBox: "0 0 1380 986",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1410 33H-30",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1410 77H-30",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1410 120H-30",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1410 164H-30",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1410 208H-30",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1410 251H-30",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1410 295H-30",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1410 339H-30",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1410 382H-30",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1410 426H-30",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1410 469H-30",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1410 513H-30",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1410 557H-30",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1410 600H-30",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1410 644H-30",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1410 688H-30",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1410 731H-30",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1410 775H-30",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1410 819H-30",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1410 862H-30",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1410 906H-30",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1410 950H-30",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9999 -20.0001L35 1004",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9999 -20.0001L78 1004",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M122 -20.0001L122 1004",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M166 -20.0001L166 1004",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M209 -20.0001L209 1004",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M253 -19.0001L253 1005",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M297 -19.0001L297 1005",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M340 -19.0001L340 1005",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M384 -19.0001L384 1005",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M427 -19.0001L427 1005",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M471 -19.0001L471 1005",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M515 -19.0001L515 1005",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M558 -19.0001L558 1005",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M602 -19.0001L602 1005",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M646 -19.0001L646 1005",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M689 -19.0001L689 1005",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M733 -19.0001L733 1005",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M777 -19.0001L777 1005",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M820 -19.0001L820 1005",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M864 -19.0001L864 1005",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M908 -19.0001L908 1005",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M951 -19.0001L951 1005",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M995 -19.0001L995 1005",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1038 -19.0001L1038 1005",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1082 -19.0001L1082 1005",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1126 -19.0001L1126 1005",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1169 -19.0002L1169 1005",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1213 -19.0001L1213 1005",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1257 -19.0001L1257 1005",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1300 -19.0001L1300 1005",
    stroke: "white",
    strokeOpacity: 0.17
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1344 -19.0001L1344 1005",
    stroke: "white",
    strokeOpacity: 0.17
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerGrid);
export default __webpack_public_path__ + "static/media/banner-grid.28d80bcfb54ca6e80f714175cceeccb3.svg";
export { ForwardRef as ReactComponent };